import $ from 'jquery'

$(function() {
  $('.chart').easyPieChart({
    scaleColor: false,
    lineCap: 'round',
    lineWidth: 6,
    size: 40,
    animate: 1000,
    onStart: $.noop,
    onStop: $.noop,
  });

  $('.chart-product').easyPieChart({
    scaleColor: false,
    lineCap: 'round',
    lineWidth: 7,
    size: 42,
    animate: 1000,
    onStart: $.noop,
    onStop: $.noop,
  });

  $('.operator-chart').easyPieChart({
    scaleColor: false,
    lineCap: 'round',
    lineWidth: 7,
    size: 50,
    animate: 1000,
    onStart: $.noop,
    onStop: $.noop,
  });
});
